// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"1496df52","892":"3192997b","952":"b83a9f02"}[chunkId] + ".chunk.js";
};